/* eslint-disable jsx-a11y/no-static-element-interactions */
import type { EventSlide } from '@/types/event';
import { getSize, getHSize } from '@/utils/size';
import useBaseSize from '@/hooks/useBaseSize';
import { useTickSoundInteraction } from '@/hooks';
import clsx from 'clsx';
import styles from './styles.module.scss';
import { useTranslation } from 'react-i18next';

interface EventGridHorizontalProps {
    slideItems: (EventSlide & { tabIndex?: number })[];
    onItemClick?: (category: string) => void;
}

export default function EventGridHorizontal({ slideItems, onItemClick }: EventGridHorizontalProps) {
    const { baseWidth, baseHeight } = useBaseSize();
    const { handleInteraction, handleKeyboardInteraction } = useTickSoundInteraction();
    const { t } = useTranslation();

    return (
        <div
            className="grid gap-[calc(24*var(--vw-unit))]"
            style={{
                gridTemplateColumns: `repeat(3, ${getSize(424, baseWidth)})`,
                gridTemplateRows: `repeat(2, ${getHSize(224, baseHeight)})`,
            }}
        >
            {slideItems.map((item) => {
                return (
                    <div
                        key={item.id}
                        data-type="button"
                        className={clsx(
                            styles['slide-item'],
                            'contrast:border-[calc(2*var(--vh-unit))] contrast:border-white flex rounded-[calc(8*var(--vh-unit))] border-[calc(2*var(--vh-unit))] border-[var(--color-primary-black-light)]'
                        )}
                        onClick={(e) => handleInteraction(e, () => onItemClick?.(item.id))}
                        tabIndex={item.tabIndex ?? 4}
                        aria-label={item.header + ' ' + item.description}
                        data-interactive
                        data-role={t('common.button.tts.button')}
                        onKeyDown={(e) => handleKeyboardInteraction(e, () => onItemClick?.(item.id))}
                    >
                        <div className="h-[calc(220*var(--vh-unit))] w-[calc(220*var(--vw-unit))] overflow-hidden rounded-l-[calc(8*var(--vh-unit))]">
                            <img src={item.imageUrl} alt={item.header} className="h-full w-full object-cover" loading="lazy" />
                        </div>

                        <div className="bg-bg-white h-[calc(220*var(--vh-unit))] w-[calc(204*var(--vw-unit))] rounded-r-[calc(8*var(--vh-unit))] px-[calc(20*var(--vh-unit))] py-[calc(20*var(--vh-unit))] text-left">
                            <div className="text-text-main01 text-[calc(20*var(--vh-unit))] leading-[calc(28*var(--vh-unit))] font-bold">{item.header}</div>
                            <div className="text-text-main01 text-[calc(20*var(--vh-unit))] leading-[calc(28*var(--vh-unit))] font-bold">
                                {item.description}
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
